<template>
	<bContainer fluid class="rb-home position-relative">
		<rb-loader center style="top: 100px;" v-if="!loaded"></rb-loader>

		<rb-collapse :collapsed="!loaded">
			<b-row class="rb-highlight py-2 py-lg-4 px-lg-4" v-if="highlights.length">

				<b-col lg="6" md="12" class="rb-hero mb-4 mb-lg-0">
					<rb-video-thumbnail
						:video="highlight"
						active
						hide-text
						play-size="xl"
						class="w-100 h-100"
					></rb-video-thumbnail>
				</b-col>

				<b-col lg="6" md="12" class="rb-details">
					<b-row>
						<b-col>
							<h3 class="float-right text-right">
								{{ highlight.Views }} <rb-icon>eye</rb-icon>
							</h3>

							<h2>
								<router-link :to="highlight.getRoute()">
									{{ highlight.Name }}

									<rb-icon class="text-first" v-if="nowLazy < highlight.getPubliclyAvailableTime()">
										star
									</rb-icon>
								</router-link>
							</h2>

							<h4>
								<router-link :to="highlight.Category.Series.getRoute()">
									{{ highlight.Category.Series.Name }}
								</router-link>
								-
								<router-link :to="highlight.Category.getRoute()">
									{{ highlight.Category.Name }}
								</router-link>
							</h4>

							<h5 class="text-grey">
								{{ highlight.Date.format('d/m/Y') }}
							</h5>

							<rb-markdown class="mb-5" :value="highlight.Description"></rb-markdown>
						</b-col>
					</b-row>

					<b-container fluid class="rb-previous">
						<b-row>
							<b-col>
								<h3>
									Vídeos Anteriores
								</h3>
							</b-col>
						</b-row>
						<b-row>
							<b-col v-for="prev in previousHighlights" :key="prev.Id" sm="6" class="mb-4 mb-lg-0">
								<rb-video-thumbnail small :video="prev" active></rb-video-thumbnail>
							</b-col>
						</b-row>
					</b-container>
				</b-col>

			</b-row>
		</rb-collapse>

		<rb-collapse :collapsed="!loaded">
			<b-row class="px-lg-4">
				<b-col>
					<h3 class="mt-4 mb-2">
						Outros vídeos recentes
					</h3>
				</b-col>
			</b-row>
			<b-row class="px-lg-4">
				<b-col v-for="prev in otherVideos" :key="prev.Id" sm="3" class="mb-2">
					<rb-video-thumbnail small :video="prev" active></rb-video-thumbnail>
				</b-col>
			</b-row>
		</rb-collapse>
	</bContainer>
</template>

<script>
	import RbVideoThumbnail from '../components/RbVideoThumbnail';
	import RbLoader from '../components/RbLoader';
	import RbCollapse from '../components/RbCollapse';
	import {mapState} from 'vuex';
	import RbMarkdown from '../components/RbMarkdown';

	export default {
		name: 'home',
		components: {
			RbMarkdown,
			RbCollapse,
			RbLoader,
			RbVideoThumbnail
		},
		data: () => ({
			highlights: [],
			loaded: false
		}),
		async mounted() {
			this.highlights = await this.$oldApi.Video.getHighlight();

			this.loaded = true;
		},
		computed: {
			...mapState([
				'nowLazy'
			]),
			highlight() {
				return this.highlights.length ? this.highlights[0] : null;
			},
			previousHighlights() {
				return this.highlights.length ? this.highlights.slice(1,3) : [];
			},
			otherVideos() {
				return this.highlights.length ? this.highlights.slice(3) : [];
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-highlight {
		background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%);
	}

	@include media-breakpoint-up(xxl) {
		.rb-details {
			position: relative;
		}

		.rb-previous {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
		}
	}

	@include media-breakpoint-down(lg) {
		.rb-previous {
			padding: 0;
		}
	}
</style>